"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SABRE_GET_BRANDS = void 0;
var client_1 = require("@apollo/client");
exports.SABRE_GET_BRANDS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetBrands($input: BrandsInput) {\n    brands(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query GetBrands($input: BrandsInput) {\n    brands(input: $input) {\n      count\n      hasMore\n      results {\n        id\n        name\n      }\n    }\n  }\n"])));
var templateObject_1;
